module.exports = __webpack_public_path__ + "static/media/1.ab3eff08.png";